import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../styles/admins/rooms/book_room.css";
import GuestModal from "../invoices/guest";

const BookMultiRoom = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [cameraStarted, setCameraStarted] = useState(false);
  const [guests, setGuests] = useState([]);
  const [addedRooms, setAddedRooms] = useState([]);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const nextDate = new Date();
  nextDate.setDate(nextDate.getDate() + 1);
const [invNo, setInvNo] = useState(null);


  const clientIs = localStorage.getItem("client_is");
  const clientDetails = JSON.parse(clientIs);

  const getCurrentDateTime = (now) => {
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    guest_ids: `{"ids":[], "name":[]}`,
    from_date: getCurrentDateTime(new Date()),
    to_date: getCurrentDateTime(nextDate),
    live_image: null,
    live_image_file: null,
    total_amount: 0,
    advance_amount: "",
    source: "Walk In",
  });

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    if (index === -1) {
      setFormData({ ...formData, [name]: value });

      if (name === "from_date" || name === "to_date") {
        const updatedFormData = {
          ...formData,
          [name]: value,
        };

        setAddedRooms((prevRooms) => {
          return prevRooms.map((room) => {
            const days = calculateDaysDifference(
              updatedFormData.from_date,
              updatedFormData.to_date
            );

            const total = days > 0 ? days * room.price : 0;

            return {
              ...room,
              total_price: total ? total.toFixed(2) : "0",
            };
          });
        });
      }
    } else {
      const updatedRooms = [...addedRooms];

      updatedRooms[index] = {
        ...updatedRooms[index],
        [name]: value,
      };

      setAddedRooms(updatedRooms);
    }
  };

  const calculateDaysDifference = (from, to) => {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const timeDifference = toDate - fromDate;
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  };

  // Handle change in number input
  const handleNumberChange = (e, index) => {
    let value = e.target.value;

    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      if (index === -1) {
        setFormData({ ...formData, [e.target.name]: value });
      } else {
        const updatedRooms = [...addedRooms];

        updatedRooms[index] = {
          ...updatedRooms[index],
          [e.target.name]: value,
        };

        setAddedRooms(updatedRooms);
      }
    }
  };


      useEffect(() => {
      axios
        .get(`https://api.dectwinhotel.com/api/get-self/${clientDetails.id}`)
        .then((response) => {
const fetchedInvNo = response.data[0].inv_no;
setInvNo(fetchedInvNo);
// console.log(response.data[0]);
      localStorage.removeItem("client_is");
localStorage.setItem("client_is", JSON.stringify(response.data[0]));

        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            window.location.reload();
          }
          console.error("Error fetching products:", error);
        });
  }, [clientDetails.id]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    props.handleLoading();
    if (guests.length < 1) {
      props.handleToast({
        toastMsg: "Something went wrong! Please Add atleast one guest.",
        toastColor: "#FF0000",
      });
      props.closeLoading();
      return;
    }
    if (addedRooms.length < 2) {
      props.handleToast({
        toastMsg: "Something went wrong! Please Add atleast Two Rooms.",
        toastColor: "#FF0000",
      });
      props.closeLoading();
      return;
    }
    const data = new FormData();
    data.append("from_date", formData.from_date);
    data.append("to_date", formData.to_date);
    data.append("source", formData.source);
    if (formData.live_image_file) {
      data.append("live_image", formData.live_image_file);
    }

    const guestIds = guests.map((guest) => guest.id);
    const guestNames = guests.map((guest) => guest.name);
    data.append(
      "guest_ids",
      JSON.stringify({ id: guestIds, name: guestNames })
    );

    data.append("inv_no", invNo);

    const roomIds = addedRooms.map((r) => r.room_id);
    const roomNums = addedRooms.map((r) => r.room_number);
    const roomStay = addedRooms.map((r) => r.no_of_stay);
    const roomPrices = addedRooms.map((r) => r.total_price || r.price);
    const roomAdv = addedRooms.map((r) => r.adv_amount || 0);
    data.append(
      "rooms_data",
      JSON.stringify({
        id: roomIds,
        number: roomNums,
        stay: roomStay,
        prices: roomPrices,
        advance: roomAdv,
      })
    );

    try {
      const response = await axios.post(
        `https://api.dectwinhotel.com/api/${props.id}_bookings/checkin-multiroom`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      props.closeLoading();
      if (response.status === 201) {
        props.handleToast({
          toastMsg: "Check In Successfully!!!",
          toastColor: "#4CAF50",
        });
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        localStorage.removeItem("rooms");
        clientDetails.inv_no = clientDetails.inv_no + 1;
        localStorage.removeItem("client_is");
        localStorage.setItem("client_is", JSON.stringify(clientDetails));
        navigate("/admin/rooms");
      } else {
        props.handleToast({
          toastMsg: "Something went wrong! Please check data or internet.",
          toastColor: "#FF0000",
        });
      }
    } catch (err) {
      props.closeLoading();
    }
  };

  const startCamera = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          setCameraStarted(true);
        }
      })
      .catch((error) => {
        console.error("Error accessing the camera", error);
      });
  };

  const captureImage = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

    // Set base64 image data for preview in <img>
    const imageData = canvas.toDataURL("image/png");
    setFormData({ ...formData, live_image: imageData });

    // Convert canvas to Blob for uploading
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], "live_image.png", { type: "image/png" });
        // Use a different state field to store the file for uploading
        setFormData((prevData) => ({ ...prevData, live_image_file: file }));
      }
    }, "image/png");

    stopCamera();
  };

  const stopCamera = () => {
    const stream = videoRef.current.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
      setCameraStarted(false);
    }
  };

  const openGuestModal = () => setShowGuestModal(true);
  const closeGuestModal = () => setShowGuestModal(false);

  const addGuestToForm = (guest) => {
    setGuests([...guests, guest]);
  };

  const removeGuest = async (guestId) => {
    props.handleLoading();
    try {
      props.closeLoading();
      setGuests(guests.filter((guest) => guest.id !== guestId));
    } catch (err) {
      props.closeLoading();
    }
  };

  const removeRoom = async (roomId) => {
    props.handleLoading();
    try {
      props.closeLoading();
      setAddedRooms(addedRooms.filter((roomss) => roomss.room_id !== roomId));
    } catch (err) {
      props.closeLoading();
    }
  };

  const sumByKey = (arr) => {
    return arr
      .reduce((total, item) => {
        return total + (parseFloat(item.total_price) || parseFloat(item.price));
      }, 0)
      .toFixed(2);
  };

  return (
    <section style={{ padding: "1rem" }}>
      <div className="book-room-form">
        <h2>Book Multiple Rooms</h2>
        <form onSubmit={handleSubmit}>
          {guests.length > 0 &&
            guests.map((guest) => (
              <div key={guest.id} className="guest-entry">
                <label htmlFor="guest_name">Guest Name</label>
                <input
                  type="text"
                  name="guest_name"
                  placeholder="Guest Name"
                  value={guest.name}
                  onChange={(e) => {}}
                  required
                />
                <button type="button" onClick={() => removeGuest(guest.id)}>
                  Remove Guest
                </button>
              </div>
            ))}
          {guests.length > 0 && <br />}
          <button type="button" onClick={openGuestModal}>
            Add Guest
          </button>

          <label htmlFor="from_date">From Date</label>
          <input
            type="datetime-local"
            name="from_date"
            value={formData.from_date}
            onChange={(e) => handleChange(e, -1)}
            required
          />

          <label htmlFor="to_date">To Date</label>
          <input
            type="datetime-local"
            name="to_date"
            min={formData.from_date}
            value={formData.to_date}
            onChange={(e) => handleChange(e, -1)}
          />

          <label
            style={{ fontWeight: "700", color: "black", fontSize: "1.2rem" }}
          >
            Added Rooms
          </label>

          {addedRooms.length > 0 &&
            addedRooms.map((room, index) => (
              <div key={index} className="guest-entry">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "50% 30% 20%",
                    gap: "10px",
                  }}
                >
                  <div>
                    <label>Select Room {index + 1}</label>
                    <select
                      value={addedRooms[index]?.room_number || ""}
                      onChange={(e) => {
                        const selectedRoom = location.state.find(
                          (roomes) => roomes.room_number === e.target.value
                        );

                        if (selectedRoom) {
                          const updated = [...addedRooms];
                          updated[index] = selectedRoom;
                          setAddedRooms(updated);
                        }
                      }}
                      required
                    >
                      {location.state.map((allRoom) => (
                        <option
                          key={allRoom.room_id}
                          value={allRoom.room_number}
                        >
                          Room No. {allRoom.room_number} - {allRoom.room_type}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label>No of Adult(s)</label>
                    <select
                      name="no_of_stay"
                      value={addedRooms[index].no_of_stay || ""}
                      onChange={(e) => handleChange(e, index)}
                      required
                    >
                      <option value="">No of Adult(s)</option>
                      {Array.from({ length: 10 }, (_, i) => i + 1).map(
                        (num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div>
                    <label>Remove</label>
                    <button
                      type="button"
                      style={{ margin: "10px 0px", width: "80%" }}
                      onClick={() => removeRoom(room.room_id)}
                    >
                      -
                    </button>
                  </div>
                </div>
                <div>
                  <label>Amount for Room No. {room.room_number}</label>
                  <div className="d-flex">
                    <input
                      type="text"
                      name="total_price"
                      placeholder="Room Rent"
                      maxLength={9}
                      value={room.total_price || room.price}
                      onChange={(e) => handleNumberChange(e, index)}
                      required
                    />
                    <select
                      style={{ margin: "10px 10px" }}
                      name="withOrWithout"
                      value={addedRooms[index].withOrWithout || "Without Tax"}
                      onChange={(e) => handleChange(e, index)}
                      required
                    >
                      <option value="Without Tax">Without Tax</option>
                      <option value="With Tax">With Tax</option>
                    </select>

                    <input
                      type="text"
                      name="adv_amount"
                      placeholder="Advance Paid"
                      maxLength={7}
                      value={addedRooms[index].adv_amount || ""}
                      onChange={(e) => handleNumberChange(e, index)}
                    />
                  </div>
                </div>
                <hr />
              </div>
            ))}

          <button
            type="button"
            onClick={() => {
              if (location.state.length > 0) {
                setAddedRooms((prevRooms) => [...prevRooms, location.state[0]]);
              }
            }}
          >
            Add Rooms
          </button>

          <label htmlFor="source">Booking Source</label>
          <input
            type="text"
            name="source"
            placeholder="Booking Source"
            maxLength={45}
            value={formData.source}
            onChange={handleChange}
          />

          <label style={{ fontWeight: "700" }}>Total Amount</label>
          <input
            type="text"
            name="total_amount"
            placeholder="Total Amount"
            maxLength={9}
            value={sumByKey(addedRooms)}
            required
            disabled
          />

          <label>Live Image</label>
          <div
            className="live-image-container"
            style={{
              border: "1px solid #ccc",
              padding: "10px 5rem",
              margin: "10px 0",
            }}
          >
            {!cameraStarted && !formData.live_image && (
              <button
                type="button"
                onClick={startCamera}
                style={{
                  padding: "8px 10px",
                  marginRight: "10px",
                  backgroundColor: "#d32bb5",
                }}
              >
                Open Camera
              </button>
            )}

            <video
              ref={videoRef}
              style={{
                width: "100%",
                height: "auto",
                display: cameraStarted ? "block" : "none",
                marginTop: "10px",
              }}
            ></video>

            {cameraStarted && (
              <canvas
                ref={canvasRef}
                style={{ display: "none" }}
                width="300"
                height="200"
              ></canvas>
            )}

            {cameraStarted && (
              <button
                type="button"
                onClick={captureImage}
                style={{
                  padding: "5px 10px",
                  marginTop: "10px",
                  backgroundColor: "#d32bb5",
                }}
              >
                Capture Image
              </button>
            )}

            {formData.live_image && (
              <div className="live-image-box">
                <span>
                  {formData.live_image
                    ? "Live Image Captured"
                    : "No image captured"}
                </span>
                <img
                  src={formData.live_image}
                  alt="Captured"
                  style={{ width: "100%", height: "auto", marginTop: "10px" }}
                />
              </div>
            )}
          </div>

          <button type="submit">Book Room</button>
        </form>
      </div>
      {showGuestModal && (
        <GuestModal
          onClose={closeGuestModal}
          addGuestToForm={addGuestToForm}
          handleToast={props.handleToast}
          id={props.id}
          handleLoading={props.handleLoading}
          closeLoading={props.closeLoading}
        />
      )}
    </section>
  );
};

export default BookMultiRoom;
